module.exports = __webpack_public_path__ + "img/23.c6d87b42.png";